import React from 'react'
import LockerMenu from '../../Components/LockerMenu'
import { PageWrapper } from '../../Styles/style'
import HeroSection from '../../Components/MainComponent/Sections/S1-Hero'
import StatsSection from '../../Components/MainComponent/Sections/S2-Stats'
import HowSection from '../../Components/MainComponent/Sections/S3'
import HowItWorksSection from '../../Components/MainComponent/Sections/S4-howItWorks'
import TokenomicsSection from '../../Components/MainComponent/Sections/S5-Tokenomics'
import DocumentSection from '../../Components/MainComponent/Sections/S6-Documentation'
import FAQSection from '../../Components/MainComponent/Sections/S7-FAQ'
import CommunitySection from '../../Components/MainComponent/Sections/S8-Community'
import Footer from '../../Components/MainComponent/Sections/Footer'

const MainPage = (props) => {
  return (
    <PageWrapper>
        <LockerMenu />
        <HeroSection/>
        <StatsSection/>
        <HowSection/>
        <HowItWorksSection/>
        <TokenomicsSection/>
        <DocumentSection/>
        <FAQSection/>
        <CommunitySection/>
        <Footer/>
    </PageWrapper>
  )
}

export default MainPage